/**
 *  Apply LZW-compression to a string and return base64 compressed string.
 *
 *  Usage to compress a string or object
 *   import { zip, unzip } from './zip'
 *
 *   // Zip a string
 *   const str = 'zip it'
 *   const base64CompressedString = zip(str)
 *
 *   // Zip an object
 *   const obj = { a: 123, b: 'zipit' }
 *   const base64CompressedString = zip(JSON.stringify(obj))
 *
 *   // Unzip the base64 compressed string back to an object.
 *   const originalObject = JSON.parse(unzip(base64CompressedString))
 */
import { Base64 } from 'js-base64'

export function zip (s) {
  try {
    const dict = {}
    const data = (s + '').split('')
    const out = []
    let currChar
    let phrase = data[0]
    let code = 256
    for (let i = 1; i < data.length; i++) {
      currChar = data[i]
      if (dict[phrase + currChar] != null) {
        phrase += currChar
      } else {
        out.push(phrase.length > 1 ? dict[phrase] : phrase.charCodeAt(0))
        dict[phrase + currChar] = code
        code++
        phrase = currChar
      }
    }
    out.push(phrase.length > 1 ? dict[phrase] : phrase.charCodeAt(0))
    for (let j = 0; j < out.length; j++) {
      out[j] = String.fromCharCode(out[j])
    }
    return Base64.encode(out.join(''))
  } catch (e) {
    console.log('Failed to zip string return empty string', e)
    return ''
  }
}

/**
 * Decompress an LZW-encoded base64 string
 */
export function unzip (base64ZippedString) {
  try {
    const s = Base64.decode(base64ZippedString)
    const dict = {}
    const data = (s + '').split('')
    let currChar = data[0]
    let oldPhrase = currChar
    const out = [currChar]
    let code = 256
    let phrase
    for (let i = 1; i < data.length; i++) {
      const currCode = data[i].charCodeAt(0)
      if (currCode < 256) {
        phrase = data[i]
      } else {
        phrase = dict[currCode] ? dict[currCode] : oldPhrase + currChar
      }
      out.push(phrase)
      currChar = phrase.charAt(0)
      dict[code] = oldPhrase + currChar
      code++
      oldPhrase = phrase
    }
    return out.join('')
  } catch (e) {
    console.log('Failed to unzip string return empty string', e)
    return ''
  }
}
